import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Flow from "../../components/Flow";
import Async from "../../core/Async";
import CourseThemeProvider from "../../core/CourseThemeProvider";
import CertificationTestAbilitiesScene from "./CertificationTestAbilitiesScene";
import { START_CERTIFICATION_TEST_EXECUTION_FLOW } from "../../consts";
import Entity from "../../components/Entity";

const getStatus = (certificationTest) => {
  if (!certificationTest) {
    return null;
  } else if (certificationTest.failedAt && certificationTest.studentCheckedAt) {
    return "failed";
  } else if (certificationTest.reviewedAt && !certificationTest.studentCheckedAt) {
    return "reviewed";
  } else if (certificationTest.completedAt && !certificationTest.approvedAt && !certificationTest.failedAt) {
    return "awaiting_revision";
  } else if (
    certificationTest.startedAt &&
    !certificationTest.completedAt &&
    moment().diff(moment(certificationTest.startedAt), "hours", true) < 1.5
  ) {
    return "continue";
  } else if (certificationTest.enabledAt && !certificationTest.startedAt) {
    return "enabled";
  } else if (certificationTest.scheduledFor && !certificationTest.startedAt) {
    return moment().format("DD-MM-YYYY") === moment(certificationTest.scheduledFor).utc().format("DD-MM-YYYY")
      ? "enabled"
      : "scheduled";
  } else if (certificationTest.createdAt && !certificationTest.startedAt) {
    return "created";
  }
  return "created";
};

class CertificationTestAbilitiesSceneContainer extends Component {
  render() {
    return (
      <Entity name="profile">
        {({ getById: getProfileById }) => {
          const profile = getProfileById(sessionStorage.getItem("id"));
          const ctStatus = getStatus(profile.certificationTest);

          return (
            <Flow
              autoStart={["continue", "enabled"].includes(ctStatus)}
              id={START_CERTIFICATION_TEST_EXECUTION_FLOW}
              params={{
                certificationTest: this.props.match.params.idCertificationTest,
              }}
            >
              {({ isPending }) => (
                <CourseThemeProvider>
                  <Async fetching={isPending}>
                    <CertificationTestAbilitiesScene status={ctStatus} certificationTest={profile.certificationTest} />
                  </Async>
                </CourseThemeProvider>
              )}
            </Flow>
          );
        }}
      </Entity>
    );
  }
}

export default withRouter(CertificationTestAbilitiesSceneContainer);
